module.exports = "/packs/images/svg/facilities/spa~24908deb3551e39ae6a7934fec0eac3f.svg";